const URL_RE = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)/;

export class ValidateRules {

  public static url = {
    validate: (value: string) => URL_RE.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid URL starting with http or https'
  };

  public static httpHeaders = {
    validate: (value: string) => !value.split('\n').some((line: string) => !/^([\w-]+)\s?:\s?(.+)$/.test(line)),
    params: [],
    message:'The {_field_} field must be a list of valid http headers'
  };

  public static awsAccessKeyId = {
    validate: (value: string) => /^[A-Z0-9]{20}$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid AWS access key id matching /^[A-Z0-9]{20}$/'
  };

  public static awsSecretAccessKey = {
    validate: (value: string) => /^[A-Za-z0-9/+=]{40}$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid AWS secret access key matching /^[A-Za-z0-9/+=]{40}$/'
  };

  public static awsRegion = {
    validate: (value: string) => /^[a-zA-Z]{2}-[a-zA-Z]{3,}-[0-9]{1}$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid AWS region name'
  };

  public static snsTopicArn = {
    validate: (value: string) => /^arn:.*/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid AWS Topic ARN'
  };

  public static kinesisStreamName = {
    validate: (value: string) => /^[a-z0-9_\-\.]+$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid AWS Kinesis stream name'
  };

  public static azureEventHubConnectionString = {
    validate: (value: string) => /^Endpoint=sb:\/\/[a-z0-9_\-\.\/]+;SharedAccessKeyName=[A-Za-z0-9_]+;SharedAccessKey=[A-Za-z0-9\+\/=]+$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid Azure Event Hub connection string'
  }

  public static azureEventHubName = {
    validate: (value: string) => /^[A-Za-z0-9_\-\.]+$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid Azure Event Hub name'
  }

  public static ubidotsToken = {
    validate: (value: string) => /^BBFF-[a-z0-9A-Z]{30,}$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid Ubidots token'
  };

  public static integerBetween = {
    validate: (value: string, { min, max }: Record<string, any> = {}) => {
      
      value = '' + value;

      // we check if the number is an integer
      if(!value.match(/^-{0,1}\d+$/))
        return false;

      const intValue = parseInt(value, 10);

      return Number(min) <= intValue && Number(max) >= intValue;

    },
    params: ['min', 'max'],
    message:'The {_field_} field must be a number between {min} and {max}'
  };

  public static hex = {
    validate: (value: string, { len }: Record<string, any> = {}) => 
      new RegExp(`^[a-fA-F0-9]{${len}}$`).test('' + value),
    params: ['len'],
    message:'The {_field_} field must be a valid {len} characters hex string'
  };

  public static hexRaw = {
    validate: (value: string, { len }: Record<string, any> = {}) => {
      const cleanedValue = value.replace(/\s/g,'')
      return new RegExp(`^[a-fA-F0-9]{2,${len}}$`).test(cleanedValue) && cleanedValue.length % 2 === 0;
    },
    params: ['len'],
    message:'The {_field_} field must be a valid 2 to {len} characters hex string'
  };

  public static deviceName = {
    validate: (value: string) => /^[a-z0-9-_]{5,50}$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid device name'
  };

  public static locationName = {
    validate: (value: string) => /^[a-z0-9-_]{5,256}$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid location name'
  };

  public static apiKeyDescription = {
    validate: (value: string) => /^[a-z0-9-_ ]{3,50}$/i.test('' + value),
    params: [],
    message:'The api description field is not valid'
  };

  public static loraParserName = {
    validate: (value: string) => /^[a-z0-9-_ ]{3,50}$/i.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid lora parser name'
  };

  public static iotCoreEndpointUrl = {
    validate: (value: string) => /^[a-zA-Z0-9-]{18}\.iot\.[a-zA-Z]{2}-[a-zA-Z]{3,}-[0-9]{1,2}\.amazonaws\.com$/.test('' + value),
    params: [],
    message:'The {_field_} field must be a valid iot core endpoint URL (/^[a-zA-Z0-9-]{18}\.iot\.[a-zA-Z]{2}-[a-zA-Z]{3,}-[0-9]{1,2}\.amazonaws\.com$/)'
  };
}
